import {useMutation, useQueryClient} from 'react-query'
import {TimeSlotException} from "../../../types";
import {showNotification} from "@mantine/notifications";
import {Check} from "tabler-icons-react";

const onMutateSuccess = (values: TimeSlotException) => {
    showNotification({
        title: 'Time slot exception updated',
        icon: <Check/>,
        message: `Time slot exception '${values.description}' has been updated!`,
    });
}

const onMutateError = (error: string) => {
    showNotification({
        title: `Something went wrong`,
        message: `An error occurred while updating the time slot exception. ${error}`,
        color: 'red'
    });
}

export default function useMutateTimeSlotExceptionData(mutationFn: (args: any) => Promise<unknown>, onSuccess: any = onMutateSuccess, onError: any = onMutateError) {
    const queryClient = useQueryClient();
    return useMutation(mutationFn, {
        onSuccess: (data) => {
            // Reload time slot exceptions data
            queryClient.invalidateQueries(['timeSlotExceptions']);

            onSuccess?.(data)
        },
        onError: (data) => onError?.(data)
    });
}
